import { COMMON_CONTENT } from './common';

export const HERO_CONTENT = {
  badge: {
    text: 'New Collection 2026',
    icon: 'Sparkles',
  },
  title: {
    line1: 'Find Your Perfect',
    line2: 'Cuddle Buddy',
    highlight: 'Cuddle Buddy',
  },
  description:
    'Handcrafted with love, our soft toys bring comfort and joy to every hug. Perfect gifts for little ones and the young at heart.',
  buttons: {
    primary: {
      label: COMMON_CONTENT.actions.shopNow,
      path: '/shop',
      icon: 'ShoppingBag',
    },
    secondary: {
      label: 'View Collection',
      path: '/shop?category=teddy',
      icon: 'Eye',
    },
  },
  stats: [
    { id: 'customers', value: '50k+', label: 'Happy Customers' },
    { id: 'designs', value: '200+', label: 'Cute Designs' },
    { id: 'rating', value: '4.9', label: 'Rating' },
  ],
  sliderImages: [
    { src: '/1.png', alt: 'Premium Soft Toy' },
    { src: '/2.png', alt: 'Handcrafted Teddy' },
    { src: '/3.png', alt: 'Cuddly Friend' },
    { src: '/4.png', alt: 'New Collection' },
  ],
  config: {
    sliderDuration: 5000,
    animationDelay: 0.5,
    animationStagger: 0.1,
  },
} as const;

export const FEATURES_CONTENT = {
  title: 'Why Choose Us',
  subtitle: 'Handcrafted excellence for your loved ones',
  features: [
    {
      id: 'free-delivery',
      icon: 'Truck',
      title: 'Free Delivery',
      description: 'On orders over ₹2500',
      color: 'blue',
    },
    {
      id: 'secure-payment',
      icon: 'ShieldCheck',
      title: 'Secure Payment',
      description: '100% protected payments',
      color: 'green',
    },
    {
      id: 'made-with-love',
      icon: 'Heart',
      title: 'Made with Love',
      description: 'Handcrafted toys',
      color: 'pink',
    },
    {
      id: 'gift-wrapping',
      icon: 'Gift',
      title: 'Gift Wrapping',
      description: 'Premium gift options',
      color: 'purple',
    },
  ],
  colorClasses: {
    blue: 'bg-blue-50 text-blue-600 border-blue-100',
    green: 'bg-green-50 text-green-600 border-green-100',
    pink: 'bg-pink-50 text-pink-600 border-pink-100',
    purple: 'bg-purple-50 text-purple-600 border-purple-100',
  },
} as const;

export const CATEGORIES_CONTENT = {
  title: 'Shop by Category',
  subtitle: 'Explore our adorable collection',
  itemsLabel: 'items',
  categories: [
    {
      id: 'FILLED-TEDDY',
      name: 'Teddy Bears',
      count: 55,
      image: '/1.png',
      icon: 'ShoppingBag',
      color: 'from-amber-400 to-amber-600',
    },
    {
      id: 'FILLED-DOLL',
      name: 'Soft Dolls',
      count: 28,
      image: '/2.png',
      icon: 'Rabbit',
      color: 'from-pink-400 to-pink-600',
    },
    {
      id: 'MUSICAL',
      name: 'Musical Toys',
      count: 30,
      image: '/3.png',
      icon: 'Music',
      color: 'from-purple-400 to-purple-600',
    },
    {
      id: 'KEYCHAIN',
      name: 'Keychains',
      count: 87,
      image: '/4.png',
      icon: 'Key',
      color: 'from-blue-400 to-blue-600',
    },
  ],
} as const;

export const PRODUCTS_CONTENT = {
  featured: {
    title: 'Featured Friends',
    subtitle: 'Curated For You',
    filters: [
      { id: 'all', label: 'All' },
      { id: 'new', label: 'New Arrivals' },
      { id: 'sale', label: 'On Sale' },
    ],
    viewAllButton: {
      label: 'View All Products',
      path: '/shop',
      icon: 'ArrowRight',
    },
    empty: {
      title: 'No friends found',
      description:
        "We couldn't find any items matching your filter. Please try a different category or check back later!",
      icon: 'Search',
    },
  },
  trending: {
    title: 'Trending Now',
    subtitle: 'Most loved this week',
    icon: 'Sparkles',
    empty: {
      title: 'No trending items yet',
      description: "We're curating the best items for you. Check back shortly!",
      icon: 'Sparkles',
    },
  },
  bestSellers: {
    title: 'Best Sellers',
    subtitle: 'Customer favorites',
    icon: 'Heart',
    empty: {
      title: 'No best sellers yet',
      description: 'Customer favorites are being calculated. Check back shortly!',
      icon: 'Star',
    },
  },
  card: {
    addToCartLabel: 'Add to Cart',
    outOfStockLabel: 'Out of Stock',
    viewDetailsLabel: 'View Details',
    newBadge: 'New',
    saleBadge: 'Sale',
    outOfStockBadge: 'Out of Stock',
    addToWishlist: 'Add to Wishlist',
    removeFromWishlist: 'Remove from Wishlist',
  },
  labels: {
    new: 'New',
    sale: 'Sale',
    outOfStock: 'Out of Stock',
  },
} as const;

export const TESTIMONIAL_CONTENT = {
  badge: {
    text: 'Loved by Thousands',
    icon: 'ShieldCheck',
  },
  title: 'What Our Customers Say',
  testimonials: [
    {
      id: 1,
      quote:
        "The quality of these soft toys is absolutely amazing! My daughter hasn't let go of her new teddy bear since we got it. The attention to detail is incredible.",
      author: {
        name: 'Sarah M.',
        title: 'Verified Buyer',
        initial: 'S',
      },
      rating: 5,
    },
    {
      id: 2,
      quote:
        'I bought a bunny for my nephew and it is his favorite toy now. So soft and safe for babies. Highly recommend BST - The Soft Studio for premium gifts!',
      author: {
        name: 'David K.',
        title: 'Happy Uncle',
        initial: 'D',
      },
      rating: 5,
    },
    {
      id: 3,
      quote:
        'The best soft toys in India! The handcrafted quality really shows. It arrived in beautiful packaging, perfect for a birthday surprise.',
      author: {
        name: 'Priya R.',
        title: 'Premium Member',
        initial: 'P',
      },
      rating: 5,
    },
    {
      id: 4,
      quote:
        'Fast shipping and excellent customer service. The unicorn we ordered is even more beautiful in person. Will definitely buy again!',
      author: {
        name: 'Anita S.',
        title: 'Gift Shopper',
        initial: 'A',
      },
      rating: 5,
    },
  ],
} as const;

export const VIDEO_SHOWCASE_CONTENT = {
  badge: {
    text: 'Behind the Scenes',
    icon: 'PlayCircle',
  },
  title: 'See Our Friends in Action',
  description: 'Experience the magic and care that goes into creating every soft companion.',
  playAria: 'Play Video',
  pauseAria: 'Pause Video',
  muteAria: 'Mute Video',
  unmuteAria: 'Unmute Video',
} as const;
